@if (showDownloadButtons) {
    <a [attr.href]="noteDownloadLink"
       class="btn btn-dark btn-sm btn-round btn-semibold download-button relative-pos">Notizen exportieren</a>
}

@if (bookFeatureActivationService.rectsActivated) {
    <app-note-info-box></app-note-info-box>
}

@if (!notes || notes.length === 0) {
    <p>Keine Notizen vorhanden</p>
}

@if (notesBeforeFirstChapter && notesBeforeFirstChapter.length > 0) {
    <div class="content-description">
    <span class="width-90">
      <span>{{ 'Notizen ohne Kapitel' }}</span>
    </span>
    </div>
}
<ul>
    @for (note of notesBeforeFirstChapter; track note) {
        <li>
            <sidebar-single-note [note]="note"></sidebar-single-note>
        </li>
    }
</ul>
@if (notes && notes.length > 0) {
    <ul>
        @for (mainChapterNote of notesInChapter; track mainChapterNote) {
            <li>
                @if (mainChapterNote.notes.length > 0) {
                    <app-main-chapter-heading [chapter]="mainChapterNote.chapter"></app-main-chapter-heading>
                    <sidebar-mainchapter-notes [mainChapterNotes]="mainChapterNote"></sidebar-mainchapter-notes>
                }
            </li>
        }
    </ul>
}
